import Drawer from './DrawerClient';
import { Screen } from '../views/Screen';

Drawer.Screen = Screen;

export { Drawer };

export default Drawer;
